import { WarningFilled } from "@ant-design/icons";
import { Modal } from "antd";

export default function ConfirmDialog({
  open,
  onCancel,
  onOk,
  title,
  subtitle,
}: {
  title?: string;
  subtitle?: string;
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}) {
  return (
    <Modal
      title="Confirm"
      closable={{ "aria-label": "Custom Close Button" }}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
    >
      <div className="my-3">
        <div className="flex flex justify-center items-center gap-2 mb-4">
          <WarningFilled className="text-red-400 text-lg" />
          <p className="font-bold text-md">
            {title ?? "Are you sure you would like to continue?"}
          </p>
        </div>
        <p className="justify-center items-center flex px-10 text-gray-800">
          {subtitle}
        </p>
      </div>
    </Modal>
  );
}
